/* ------------------------------------------------------------------
   Typewriter hints in the search box.

   The placeholder types out one category at a time — "Search for
   books", "Search for novels", and so on — so a customer landing on the
   site can see what the shop actually stocks without having to guess at
   a search term. It keeps running inside the search sheet, where the
   box is empty and waiting.

   To change what it offers, edit this one line. Order matters: the
   first word is the one most people will see, because it is the one
   showing when the page paints.
------------------------------------------------------------------- */
var SEARCH_HINT_WORDS = ['books', 'stationery', 'novels', 'notebooks', 'pens', 'manga', 'school supplies', 'gifts'];
var SEARCH_HINT_PREFIX = 'Search for ';

(function () {
  /* Milliseconds. Typing is a touch slower than erasing, the way real
     typing is, and the hold is long enough to actually read the word. */
  var TYPE = 75, ERASE = 40, HOLD = 1500, GAP = 350, BLINK = 500;

  var words = (SEARCH_HINT_WORDS || []).filter(Boolean);
  if (words.length < 2) return;

  /* Anyone who has asked their device to cut down on motion keeps the
     plain placeholder the theme already renders. */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function attach(input) {
    if (!input || input.dataset.searchHints) return;
    input.dataset.searchHints = '1';

    /* What the theme shipped with — restored whenever the customer is
       actually using the box, so a moving hint never fights their typing. */
    var base = input.getAttribute('placeholder') || '';

    var w = 0, n = 0, erasing = false, caretOn = true;
    var step = null, blink = null, stopped = true;

    function paint() {
      /* The caret swaps for a thin space rather than vanishing, so the
         hint does not twitch a pixel left and right as it blinks. */
      input.setAttribute('placeholder', SEARCH_HINT_PREFIX + words[w].slice(0, n) + (caretOn ? '|' : ' '));
    }

    function tick() {
      if (stopped) return;
      if (!erasing) {
        if (n < words[w].length) { n++; paint(); step = setTimeout(tick, TYPE); }
        else { erasing = true; step = setTimeout(tick, HOLD); }
      } else {
        if (n > 0) { n--; paint(); step = setTimeout(tick, ERASE); }
        else { erasing = false; w = (w + 1) % words.length; step = setTimeout(tick, GAP); }
      }
    }

    function start() {
      if (!stopped || input.value) return;
      stopped = false;
      caretOn = true;
      blink = setInterval(function () { caretOn = !caretOn; paint(); }, BLINK);
      paint();
      tick();
    }

    function stop(restore) {
      stopped = true;
      clearTimeout(step);
      clearInterval(blink);
      if (restore && base) input.setAttribute('placeholder', base);
    }

    /* The hint keeps cycling while the box is focused and empty — inside
       the search sheet too, which is where most people first read it. It
       gets out of the way the moment there is something typed. */
    input.addEventListener('input', function () {
      if (input.value) { stop(true); return; }
      n = 0; erasing = false;
      start();
    });
    input.addEventListener('blur', function () {
      if (input.value) return;
      n = 0; erasing = false; w = 0;
      start();
    });

    /* No point animating a tab nobody is looking at. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(false);
      else if (document.activeElement !== input) start();
    });

    start();
  }

  function init() {
    var inputs = document.querySelectorAll('#HeaderSearchInput, .search-page__form input[type="search"]');
    for (var i = 0; i < inputs.length; i++) attach(inputs[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
